



import AttributeLabelsModule from '@/store/AttributeLabelsModule'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AttributeLabel extends Vue {
  @Prop({ required: true }) attributeKey!: string

  get value() {
    return this.$store.getModule(AttributeLabelsModule).labels[this.attributeKey]
  }
}
